import $http from "@/http/index";

//根据类型获取公示信息
export const informationInfo = (data) => {
  return $http.get("/api/publicInformation/info/" + data.moduleType, {
    params: {}
  })
}
